import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BuildingBorderService } from 'src/app/geometrics-form/building-borders/state/building-border.service';
import { BuildingService } from 'src/app/geometrics-form/buildings/state/building.service';
import { EdgeService } from 'src/app/geometrics-form/edges/state/edge.service';
import { VertexService } from 'src/app/geometrics-form/vertexes/state/vertex.service';
import { LayerItem, MapService } from 'src/app/shared/components/map/map.service';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { ProjectDemographicAreasService } from '../service/project-demographic-areas.service';

@Component({
  selector: 'app-layer-visualization-control',
  templateUrl: './layer-visualization-control.component.html',
  styleUrls: ['./layer-visualization-control.component.scss']
})
export class LayerVisualizationControlComponent implements OnInit, OnDestroy {

  @Input()
  resultMode: boolean;

  treeControl = new NestedTreeControl<TreeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<TreeNode>();

  layerNames = LAYER_NAMES;

  legends = {
    'mitra-filter-vertex': [],
    'mitra-filter-edge': [],
    'mitra-filter-building': []
  };

  constructor(
    private mapService: MapService,
    private simulationQuery: SimulationQuery,
    private vertexService: VertexService,
    private edgeService: EdgeService,
    private buildingService: BuildingService,
    private buildingBorderService: BuildingBorderService,
    private projectDemographicAreas: ProjectDemographicAreasService
  ) { }

  ngOnInit(): void {
    this.loadLayers();
  }

  ngOnDestroy(): void {
    this.dataSource.data = [];
  }

  loadChildren(layer: LayerItem): TreeNode[] {
    if (layer.id === 'mitra-vertex') {
      return createVertexesChildren();
    }
    if (layer.id === 'mitra-edge') {
      return createEdgeChildren();
    }
    if (layer.id === 'mitra-building') {
      return createBuildingChildren();
    }
    return [];
  }

  hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;

  expand(node: TreeNode, maxLevel: number) {
    if (maxLevel > 3) {
      return;
    }
    this.treeControl.expand(node);
    if (node.children) {
      node.children.forEach(child => this.expand(child, ++maxLevel));
    }
  }

  update(node: TreeNode) {
    // if (node.id !== ProjectDemographicAreasComponent.DEMOGRAPHIC_LAYER_ID) {
    node.visible = !node.visible;
    // }
    this.change(node, node.visible);
  }

  change(node: TreeNode, visible: boolean) {

    if (node.id === ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID) {
      node.visible = visible;
      node.children.forEach(child => {
        child.visible = visible;
        this.mapService.setLayerVisibility(child.id, visible);
        const layerSufixx = child.id.split('-').pop();
        this.mapService.setLayerVisibility(this.projectDemographicAreas.demLayerLabelId(layerSufixx), visible);
        // this.mapService.setLayerVisibility(this.projectDemographicAreas.demLayerBorderId(layerSufixx), visible);
      });
      return;
    } else if (node.id.startsWith(ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID)) {
      this.mapService.setLayerVisibility(node.id, visible);
      const layerSufixx = node.id.split('-').pop();
      this.mapService.setLayerVisibility(this.projectDemographicAreas.demLayerLabelId(layerSufixx), visible);
      // this.mapService.setLayerVisibility(this.projectDemographicAreas.demLayerBorderId(layerSufixx), visible);
      return;
      // this.projectDemographicAreas.getAllBorderLayerIds().forEach(
      //   layerID => {
      //     this.mapService.setLayerVisibility(layerID, visible);
      //   }
      // );
      // this.projectDemographicAreas.getAllLayerIds().forEach(
      //   layerID => {
      //     this.mapService.setLayerVisibility(layerID, visible);
      //   }
      // );
      // this.projectDemographicAreas.getAllLayerIds().forEach(
      //   layerID => {
      //     this.mapService.setLayerVisibility(layerID, visible);
      //   }
      // );
    }

    if (createVertexesChildren().find(t => t.id === node.id)) {
      const filter = this.legends['mitra-filter-vertex'];
      this.filterVertex(visible, filter, node);
      return;
    }

    if (createEdgeChildren().find(t => t.id === node.id)) {
      const filter = this.legends['mitra-filter-edge'];
      this.filterEdge(visible, filter, node);
      return;
    }

    if (createBuildingChildren().find(t => t.id === node.id)) {
      const filter = this.legends['mitra-filter-building'];
      this.filterBuilding(visible, filter, node);
      return;
    }

    this.filterPlotter(visible, node);
  }

  private loadLayers(): void {
    this.mapService.layers$
      .subscribe(layers => {
        const list = layers.filter(l => l.id.includes('result') === this.resultMode);
        if (list.length === this.dataSource.data.length) {
          this.dataSource.data.forEach(n => {
            n.visible = list.find(l => l.id === n.id).visible;
          });
          return;
        }

        let demographicLoaded = false;
        let newData = list.filter(l => !LAYERS_IGNORE.some(li => l.id.startsWith(li)))
          .map(layer => {
            if (layer.id.startsWith(ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID)) {
              demographicLoaded = true;
              return {
                ...layer,
                visible: true,
                children: this.demLayerChildren(list)
              } as TreeNode;
            }
            return {
              ...layer,
              visible: layer.visible,
              children: this.loadChildren(layer)
            } as TreeNode;
          });

        if (list.some(l => l.id.startsWith(ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID))) {
          const layerDem = list.find(l => l.id.startsWith(ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID));
          const demNode = {
            ...layerDem, visible: true,
            children: this.demLayerChildren(list)
          } as TreeNode;
          demNode.name = LAYER_NAMES.DEMOGRAPHIC_LAYER_ID;
          demNode.id = ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID;
          newData = [...newData, demNode];
        }
        this.dataSource.data = newData;
      });

  }

  private filterVertex(visible: boolean, filter: any[], node: TreeNode) {
    if (visible) {
      filter.push(node.map_legend);
    }
    else {
      filter.splice(filter.indexOf(node.map_legend), 1);
    }
    this.vertexService.filter(filter);
  }

  private filterEdge(visible: boolean, filter: any[], node: TreeNode) {
    if (visible) {
      filter.push(node.map_legend);
    }
    else {
      filter.splice(filter.indexOf(node.map_legend), 1);
    }
    this.edgeService.filter(filter);
  }

  private filterBuilding(visible: boolean, filter: any[], node: TreeNode) {
    if (visible) {
      filter.push(node.map_legend);
    }
    else {
      filter.splice(filter.indexOf(node.map_legend), 1);
    }
    this.buildingService.filter(filter);
  }

  private filterPlotter(visible: boolean, node: TreeNode) {
    this.mapService.map$.subscribe(m => {
      const visibility = visible ? 'visible' : 'none';
      m.setLayoutProperty(node.id, 'visibility', visibility);
    });

    if (!visible) {
      if (node.id === 'mitra-vertex') {
        this.legends['mitra-filter-vertex'] = [];
        this.vertexService.filter([]);
      }
      if (node.id === 'mitra-edge') {
        this.legends['mitra-filter-edge'] = [];
        this.edgeService.filter([]);
      }
      if (node.id === 'mitra-building') {
        this.legends['mitra-filter-building'] = [];
        this.buildingService.filter([]);
      }
      if (node.id === 'mitra-building-border') {
        this.legends['mitra-filter-building-border'] = [];
        this.buildingBorderService.filter([]);
      }
      this.treeControl.collapseDescendants(node);
      node.children.forEach(n => n.visible = false);
    }

  }

  filter(layers: LayerItem[]) {
    if (!layers) {
      return [];
    }
    if (this.simulationQuery.getValue().resultMode) {
      return layers.filter(l => l.id.startsWith('mitra-result'));
    }
    return layers.filter(l => !l.id.startsWith('mitra-result'));
  }

  private demLayerChildren(list: LayerItem[]): TreeNode[] {
    return list.filter(childLayer => childLayer.id.startsWith(ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID)).map(
      childLayer => {
        return {
          ...childLayer,
          visible: true,
          children: []
        } as TreeNode;
      }
    );
  }
}

interface TreeNode {
  id: string;
  name: string;
  visible?: boolean;
  map_legend?: string;
  children?: TreeNode[];
}

function createVertexesChildren(): TreeNode[] {
  return [
    {
      id: 'mitra-filter-vertex-co',
      name: $localize`CENTRAL OFFICE`,
      map_legend: 'CO'
    },
    {
      id: 'mitra-filter-vertex-ac',
      name: $localize`AERIAL CONNECTION`,
      map_legend: 'AC'
    },
    {
      id: 'mitra-filter-vertex-pl',
      name: $localize`POLE`,
      map_legend: 'PL'
    },
    {
      id: 'mitra-filter-vertex-pl_end_of_line',
      name: $localize`POLE (END-OF-LINE)`,
      map_legend: 'PL End of line'
    },
    {
      id: 'mitra-filter-vertex-pl_disconnected',
      name: $localize`POLE Disconnected`,
      map_legend: 'PL Disconnected'
    },
    {
      id: 'mitra-filter-vertex-ub',
      name: $localize`MANHOLE`,
      map_legend: 'UB'
    }
  ];
}

function createEdgeChildren(): TreeNode[] {
  return [
    {
      id: 'mitra-filter-edge-a',
      name: $localize`AERIAL CABLE`,
      map_legend: 'A'
    },
    {
      id: 'mitra-filter-edge-u',
      name: $localize`UNDERGROUND CABLE`,
      map_legend: 'U'
    },
    {
      id: 'mitra-filter-edge-l',
      name: $localize`LATERAL CABLE`,
      map_legend: 'L'
    }
  ];
}

function createBuildingChildren(): TreeNode[] {
  return [
    {
      id: 'mitra-filter-building-building',
      name: $localize`BUILDING`,
      map_legend: 'Building'
    },
    {
      id: 'mitra-filter-building-zero_demand',
      name: $localize`ZERO DEMAND`,
      map_legend: 'Zero demand'
    },
    {
      id: 'mitra-filter-building-disconnected',
      name: $localize`DISCONNECTED`,
      map_legend: 'Disconnected'
    },
  ];
}

const LAYER_NAMES = {
  BUILDING: $localize`BULDING`,
  EDGE: $localize`EDGE`,
  VERTEX: $localize`VERTEX`,
  'BUILDING-CONN': $localize`BUILDING CONNECTION`,
  'BUILDING-BORDER': $localize`BUILDING BORDER`,
  'BUILDING-CLASSIFICATION': $localize`BUILDING CLASSIFICATION`,
  SQUARE: $localize`SQUARE`,
  DEMOGRAPHIC_LAYER_ID: $localize`DEMOGRAPHIC AREA`
};

const LAYERS_IGNORE = ['mitra-pulse-layer', //ProjectDemographicAreasComponent.DEMOGRAPHIC_LAYER_BORDER_ID,
  ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_LABEL_ID, ProjectDemographicAreasService.DEMOGRAPHIC_LAYER_ID];
